import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment as env } from '../../environments/environment';


@Component({
  selector: 'app-res-form',
  templateUrl: './res-form.component.html',
  styleUrls: ['./res-form.component.css']
})
export class ResFormComponent implements OnInit {
  isError: boolean;
  isSuccess: boolean;
  formmsg:string;
  isLoading:boolean;
  constructor(private http: HttpClient) { }

  ngOnInit(): void { 
    window.scroll(0,800);
  }

  onFrmSubmit(f: NgForm) {
    this.isLoading = true;
    this.http.post(env.apiurl+'add-reserve', {
      rName:f.value.name,
      rEmail:f.value.email,
      rphone:f.value.phone,
      rNoofpeople:f.value.no_people,
      rDate:f.value.date,
      rArrivaltime:f.value.ar_time,
      rAmpm:f.value.ampm,
      rMessage:f.value.message,

    }).subscribe(rawData=>{
      if (rawData['success'] == true){
        f.reset();
        this.isError = false;
        this.isSuccess = true;
        this.isLoading = false;
        this.formmsg = rawData['message'];
      }else{
        this.isError = true;
        this.isSuccess = false;
        this.isLoading = false;
        this.formmsg = rawData['data'];
      }
    });


  }

}
